import _ from 'underscore';

import {assertAndContinue} from 'Asserts';

/**
 * Helper function for logging a warning in BenchlingQuery.
 *
 * This has to be wrapped with once because of an issue with tying GraphQL to the render lifecycle of React
 * components - we'd prefer to log once when queries come down, but this function will be called on each
 * render, which could be many times for the same id (e.g. this component may get rerendered if the user
 * selects the cell, which would trigger another error). This may lead to fewer errors than actually occur
 * (once per user-session) but that seems better than logging once per component render (especially because
 * multiple rows may run into this).
 */
export const warnOnce = _.once((message: string) => {
  assertAndContinue(false, message);
});
